import { apiSlice } from '@/store/api/apiSlice';

export interface Antardasha {
  planet: string;
  start: string;
  end: string;
}

export interface AntardashaArgs {
  userId: string;  
  mahaDasha: string; 
}

export const antardashaApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAntardasha: builder.query<Antardasha[], AntardashaArgs>({
      query: ({ userId, mahaDasha }) => ({
        url: 'astrology/antradasha',
        method: 'GET',
        params: {
          userId,      
          mahaDasha,  
        },
      }),
    }),
  }),
});

export const { useLazyGetAntardashaQuery } = antardashaApi;
